import http from './http'

export default {
  eidtPwd(parmes) {
    return http.post('/Passport/findPasswordByEmailCode', parmes)
  },
  login(parmes) {
    return http.post('Passport/loginConfirm', parmes)
  },
  resgUser(parmes) {
    return http.post('Passport/regUser', parmes)
  },
  senEei(parmes) {
    return http.post('Passport/sendEmailCode', parmes)
  },
  histList(parmes) {
    return http.get('Paper/my', parmes)
  },
  appPres(parmes) {
    return http.post('Passport/sendEmailCode', parmes)
  },
  addAuth(parmes) {
    return http.post('PaperAuthor/add', parmes)
  },
  addPaper(parmes) {
    return http.post('Paper/add', parmes)
  },
  upFile(parmes, sta) {
    return http.post('Files/send', parmes, sta)
  },
  delPre(parmes) {
    return http.post('Paper/delete', parmes)
  },
  getProvince(parmes) {
    return http.post('Province/getList', parmes)
  },
  getCity(parmes) {
    return http.post('City/getList?provinceid=' + parmes)
  },
  getAuthorList(parmes){

    return http.get('PaperAuthor/my',parmes)
  },
  getAuthor(parmes) {
    return http.get('PaperAuthor/detail?id=' + parmes)
  },
  eidtAuthor(parmes) {
    return http.post('PaperAuthor/edit', parmes)
  },
  getNameValueList(parmes) {
    return http.post('Config/getNameValueList', parmes)
  },
}
